// THE NOTIFICATIONS IN AN AI ANSWER — the `notifications` view (functions/
// workspaceAnswer.js workspaceAiViews): the bell's list, unread first, in the
// shared list frame (components/AssistantViewList.js). A row opens what the
// bell row opens; nothing is marked read here.
export const NotificationsAnswerView = {
  extends: 'AssistantViewList',
  dataAnswerView: 'notifications',
  viewLoad: 'notificationsAnswerLoad',
  viewModel: 'notificationsAnswerModel'
}
